/*
 * @Author: liyu
 * @Date: 2022-04-25 10:30:40
 * @LastEditTime: 2022-05-11 11:04:38
 * @Description: file content
 * @FilePath: /sensors-www/src/components/Entertainment/EntertainmentBanner/index.tsx
 */
import React, { ReactNode } from 'react'
import classnames from 'classnames'
import EntertainmentButton from 'components/Entertainment/EntertainmentButton'
import SectionSwiperMobile from 'components/SectionSwiperMobile'
import MousewheelSwiper from 'components/MousewheelSwiper'
import SectionSubstance, { SectionSubstanceBody } from 'components/SectionSubstance'
import * as styles from './index.module.less'

interface EntertainmentBannerProps {
  bannerTitle?: string
  bannerTitleMobile?: string
  bannerDesc?: string | ReactNode
  bannerButtonClassName?: string
  bannerButtonText?: string
  bannerButtonHref?: string
  sectionTwoTitle?: string
  sectionTwoTitleMB?: string
  sectionTwoDesc?: string
  qrcodeButtonText?: string
  dataSource: {
    qrcodeUrl?: string
    dataTitle?: string
    descList?: string[]
    buttonHref?: string
    buttonText?: string
  }[]
  qrcodeUrl?: string
  qrcodeDesc?: string
  bgPC?: string
  bgMB?: string
  bannerIcon?: string
  bannerIconMB?: string
  iconClassName?: string
  bannerClassName?: string
  bannerLeftClassName?: string
  bannerRightClassName?: string
  bannerIconClassName?: string
  bannerTitleClassName?: string
  bannerDescClassName?: string
  sectionTwoWrapClassName?: string
  bannerCenter?: boolean
  sectionTwoTitleLeftInMobile?: boolean
  slotBannerTitle?: ReactNode
  slotBannerDesc?: ReactNode
  slotTab?: ReactNode
  slotBannerIcon?: ReactNode
  slotBannerButton?: ReactNode
  slotSectionTwoMobileButton?: ReactNode
  swiperContentClassName?: string
  swiperClassName?: string
}
/**
 *
 * @param bannerCenter banner是否居中显示，如果存在居中显示，如果不存在左右布局
 * @param bgPC pc端背景
 * @param bgMB 移动端背景
 * @param bannerTitle banner标题
 * @param bannerTitleMobile banner标题移动端，不存在时默认使用 bannerTitle
 * @param bannerDesc banner描述
 * @param bannerButtonClassName banner 按钮类名
 * @param bannerButtonText banner按钮名
 * @param bannerButtonHref banner按钮链接
 * @param sectionTwoTitle 第二屏标题
 * @param sectionTwoTitleMB 第二屏移动端标题，如果不存在默认使用 sectionTwoTitle
 * @param sectionTwoDesc 第二屏描述
 * @param dataSource 第二屏轮播
 * @param iconClassName banner Icon class 类名
 * @param bannerClassName banner容器 class 类名
 * @param bannerLeftClassName banner文案容器 class 类名
 * @param bannerRightClassName bannerIcon 容器 class 类名 (废弃)
 * @param bannerIconClassName bannerIcon 容器 class 类名
 * @param bannerTitleClassName banner 标题 class 类名
 * @param bannerDescClassName banner 描述 class 类名
 * @param sectionTwoWrapClassName 第二屏容器 class 类名
 * @param slotBannerTitle banner标题插槽，如果存在默认样式会被覆盖
 * @param slotBannerDesc banner描述插槽，如果存在默认样式会被覆盖
 * @param slotTab Tab插槽
 * @param slotBannerIcon bannerIcon插槽，如果存在，默认icon位置不显示
 * @param slotBannerButton banner按钮插槽，如果存在 默认按钮不显示
 * @param slotSectionTwoMobileButton 第二屏移动端轮播下面的按钮插槽，如果存在默认显示二维码弹窗按钮
 * @param sectionTwoTitleLeftInMobile 第二屏标题移动端左对齐 boolean类型，默认 false
 * @param swiperClassName swiper 容器 class 类名
 * @param swiperContentClassName swiper-content 容器 class 类名
 * @returns
 */
const EntertainmentBanner: React.FC<EntertainmentBannerProps> = ({
  bannerTitle,
  bannerTitleMobile,
  bannerDesc,
  bannerButtonClassName,
  bannerButtonText,
  bannerButtonHref,
  sectionTwoTitle,
  sectionTwoTitleMB,
  sectionTwoDesc,
  dataSource,
  qrcodeButtonText,
  qrcodeUrl,
  qrcodeDesc,
  bgPC,
  bgMB,
  bannerIcon,
  bannerIconMB,
  iconClassName,
  bannerClassName,
  bannerLeftClassName,
  bannerRightClassName,
  bannerIconClassName,
  bannerTitleClassName,
  bannerDescClassName,
  sectionTwoWrapClassName,
  bannerCenter,
  sectionTwoTitleLeftInMobile = false,
  slotBannerTitle,
  slotBannerDesc,
  slotTab,
  slotBannerIcon,
  slotBannerButton,
  slotSectionTwoMobileButton,
  swiperContentClassName,
  swiperClassName,
}) => {
  return (
    <section className={styles.EntertainmentBannerWrap}>
      <article className={classnames('banner-container h-auto lg:h-[600px]', bannerClassName)}>
        {bgPC && <img className="banner-bgc hidden lg:block" src={bgPC} />}
        {bgMB && <img className="banner-bgc banner-bgc-mb block lg:hidden" src={bgMB} alt="" />}
        <div
          className={classnames('banner-content relative', {
            'relative max-w-[1200px] mx-auto': bannerCenter,
          })}
        >
          <div
            className={classnames(
              'banner-left pt-[4rem] lg:pt-[120px] w-auto relative z-20',
              { 'lg:w-[588px]': !bannerCenter },
              {
                'lg:w-full text-center relative z-10 center': bannerCenter,
              },
              bannerLeftClassName,
            )}
          >
            {slotBannerTitle ? (
              slotBannerTitle
            ) : (
              <>
                <div
                  className={classnames('banner-title hidden lg:block w-full text-left', bannerTitleClassName)}
                  dangerouslySetInnerHTML={{ __html: bannerTitle as string }}
                />
                <div
                  className={classnames('banner-title block lg:hidden w-full text-center', bannerTitleClassName)}
                  dangerouslySetInnerHTML={{ __html: (bannerTitleMobile || bannerTitle) as string }}
                />
              </>
            )}
            {slotBannerDesc ? (
              slotBannerDesc
            ) : (
              <div
                className={classnames(
                  'banner-dsc text-center lg:text-left',
                  {
                    'mt-[30px]': bannerCenter,
                  },
                  bannerDescClassName,
                )}
              >
                {bannerDesc}
              </div>
            )}
            {!slotBannerButton && (
              <div
                className={classnames(
                  'banner-btn mt-[3rem] lg:mt-[30px] text-center lg:text-left',
                  bannerButtonClassName,
                )}
              >
                <EntertainmentButton btnType="primary" href={bannerButtonHref} target="_blank">
                  {bannerButtonText}
                </EntertainmentButton>
              </div>
            )}
            {slotBannerButton}
          </div>
          {!slotBannerIcon && (
            <div
              className={classnames(
                'banner-right relative z-10 w-full lg:w-[588px] mt-[2rem] lg:mt-0 mx-auto lg:mx-0 flex items-center',
                {
                  center: bannerCenter,
                },
                iconClassName,
                bannerRightClassName,
                bannerIconClassName,
              )}
            >
              <img className={classnames('w-full hidden lg:block')} src={bannerIcon} />
              <img className={classnames('w-full block lg:hidden')} src={bannerIconMB} />
            </div>
          )}
          {slotBannerIcon}
        </div>
      </article>
      {/* tab 插槽位置 */}
      {slotTab}
      <SectionSubstance
        className={classnames('relative z-10', sectionTwoWrapClassName)}
        title={sectionTwoTitle}
        titleMb={sectionTwoTitleMB || sectionTwoTitle}
        descText={sectionTwoDesc}
        titleTextAlignMb={sectionTwoTitleLeftInMobile ? 'left' : ''}
      >
        <MousewheelSwiper
          className="hidden lg:block"
          dataSource={dataSource}
          swiperContentClassName={swiperContentClassName}
          swiperClassName={swiperClassName}
        />
        <SectionSwiperMobile
          className="block lg:hidden mt-[2rem]"
          qrcodeDesc={qrcodeDesc}
          qrcodeUrl={qrcodeUrl}
          dataSource={dataSource}
          qrcodeButtonText={qrcodeButtonText || '扫码获取方案资料'}
          slotButton={slotSectionTwoMobileButton}
        />
      </SectionSubstance>
    </section>
  )
}

export default EntertainmentBanner
